import Skeleton from "react-loading-skeleton";
import { Link, useParams } from "react-router-dom";

import { useBriefs } from "@/hooks/queries/useBriefs";

export type BriefCrumbProps = {
  to: string;
};
export const BriefCrumb = (props: BriefCrumbProps) => {
  const { briefId = "" } = useParams<{ briefId: string }>();
  const { useGetBrief } = useBriefs();
  const { data: brief, isPending } = useGetBrief(briefId);
  if (isPending) {
    return <Skeleton width="100px" height="1rem" />;
  }
  return <Link to={props.to}>{brief?.data?.name}</Link>;
};
